/* eslint-disable */
import React from "react";
import { Commodities } from '../../../controls/Commodities';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";
import { SLIDE_NUMBER } from "../constants";
import { orderBy } from "lodash";

interface CommoditiesControlItem {
    id: string;
    name: string;
    parent?: string,
    olapCommodity: number,
    origin: number,
    disabled: boolean,
}

export const CommoditiesControl: React.FC = () => {
    const [controlItems, setControlItems] = React.useState<CommoditiesControlItem[]>([]);
    const [defaultCommodityValue, setDefaultCommodityValue] = React.useState<number | undefined>();
    const [commodityDisplay, setCommodityDisplay] = useParameter<number | null>("@commodities_display");
    const [commodityValue, setCommodityValue] = useParameter<number | null>("@commodities");

    React.useEffect(function initDefaultValue() {
        if (defaultCommodityValue === undefined && commodityValue !== null) {
            setDefaultCommodityValue(commodityValue);
        }
    }, [defaultCommodityValue, commodityValue]);

    const [dictItems] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
        business_unit: 1,
        slide: SLIDE_NUMBER,
    });

    React.useEffect(function updateControlItems() {
        if (dictItems) {
            const sortedDictItems = orderBy(dictItems, item => item.getValue<number>("order"));
            const nextControlItems = sortedDictItems.map<CommoditiesControlItem>(dictItem => ({
                id: dictItem.id,
                origin: Number(dictItem.id),
                name: (dictItem.getValue("name") as any)[9] as string,
                parent: dictItem.getValue<number>("parent")?.toString(),
                olapCommodity: Number(dictItem.getValue<number>("olap_commodity")),
                disabled: dictItems.some(x => x.getValue<number>('parent')?.toString() === dictItem.id),
            }));
            setControlItems(nextControlItems);

            let selectedItem = nextControlItems.find(item => item.olapCommodity === commodityValue);
            if (selectedItem === undefined) {
                const defaultItem = nextControlItems.find(item => item.olapCommodity === defaultCommodityValue);
                const firstItem = nextControlItems[0];
                selectedItem = defaultItem || firstItem;
            }
            
            if (commodityDisplay !== selectedItem.origin) {
                setCommodityDisplay(selectedItem.origin);
            }
            if (commodityValue !== selectedItem.olapCommodity) {
                setCommodityValue(selectedItem.olapCommodity);
            }
        }
    }, [dictItems]);

    const onChange = React.useCallback(values => {
        const selectedId = (values as string[])[0];
        const selectedItem = controlItems.find(item => item.id === selectedId);
        if (selectedItem) {
            setCommodityDisplay(selectedItem.origin);
            setCommodityValue(selectedItem.olapCommodity);
        }
    }, [controlItems, commodityValue, commodityDisplay]);

    const loader = React.useMemo(() => {
        return <Skeleton variant="rect" width="168px" height="51px" />;
    }, []);

    const control = React.useMemo(() => {
        const value = [String(commodityDisplay)];
        return <Commodities label="Crops" items={controlItems} value={value} onChange={onChange} />
    }, [controlItems, commodityDisplay, onChange]);

    const loading = [commodityDisplay, controlItems.length].some(x => !Boolean(x));
    return loading ? loader : control;
};
